import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { resolveErrorMessage } from '../error-message';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private snackBar: MatSnackBar,
  ) { }

  success(msg = '', title = '') {
    this.show(title, msg, 'toast-success');
  }

  info(title: string = '', msg: string = '') {
    this.show(title, msg, 'toast-info');
  }

  danger(msg: string = '', title = 'Error!') {
    this.show(title, msg, 'toast-danger');
  }

  private show(title: string, msg: string, panelClass: string) {
    const message = title && msg ? `${title} — ${msg}` : (title || msg);
    const config: MatSnackBarConfig = {
      duration: 4000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: [panelClass]
    };
    this.snackBar.open(message, '', config);
  }
}
